"use client";

import { useEffect, useState } from "react";
import type { ComponentType } from "react";

export default function DesktopTableOfContents() {
  const [TableOfContents, setTableOfContents] =
    useState<ComponentType | null>(null);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1024px)");
    if (!mediaQuery.matches) return;

    let cancelled = false;

    import("./TableOfContents").then((mod) => {
      if (!cancelled) {
        setTableOfContents(() => mod.default);
      }
    });

    const handleChange = (event: MediaQueryListEvent) => {
      if (event.matches) {
        import("./TableOfContents").then((mod) => {
          if (!cancelled) {
            setTableOfContents(() => mod.default);
          }
        });
      } else {
        setTableOfContents(null);
      }
    };

    mediaQuery.addEventListener("change", handleChange);
    return () => {
      cancelled = true;
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  if (!TableOfContents) return null;

  return <TableOfContents />;
}
